<template lang="pug">
.ProgressBar(:style="`width:${pxToRem(w)};height:${pxToRem(h)};left:${pxToRem(l)};top:${pxToRem(t)};`")
    input(type="range" v-model="val" @change="onchange" @input="oninput" :step="0.01" ref="range")
    //- span {{val}}

</template>
<script>
//ProgressBar(ref="pb" @vol="onpb" w=1920 h=10 l=0 t=1050)
import gsap from 'gsap'
export default {
    props:{
        value:{default:0},
        w: {default: 100},
        h: {default: 100},
        l: {default: 0},
        t: {default: 0},
    },
    data(){
        return{
            val:-1,
            min:0,
            max:100,
            canemit: true,
            vwid: 440,

            isSeeking: false,
        }
    },
    camputed:{
    },
    watch:{
        val(n){
            // console.log(n)
            // gsap.set(this.$refs.drag,{top: n+'rem'})
            // if(this.canemit){
            //     this.canemit=false
            //     this.$emit("vol",{"vol":Number(n)})
                
            // }
            // gsap.set(this.$refs.idx,{scaleX: n/100 , transformOrigin: "left center"})
            // const tthis=this
            // setTimeout(()=>{tthis.canemit=true},3000)
            this.vwid=n
            gsap.set(this.$refs.range,{backgroundSize: this.val+'% 100%'})
        }
    },
    components:{

    },
    mounted(){
        this.val=this.value
    },
    methods:{
        onchange(e){
            // console.log('onchange:',e.target.value)
            this.$emit("vol",{"val":Number(e.target.value)})
        },
        pxToRem(val){
            return `${val/14*.5}rem`
        },
        setVal(val){
            if(this.isSeeking){
                return
            }else{
                this.val=val
            }
        },
        setSeeking(bl){
            this.isSeeking=bl
        },
        oninput(){
            // console.log('oninput:',e.target.value)
            this.isSeeking=true
        }
    }

}
</script>

<style lang="sass" scoped>
@import '@/styles/common'
@import '@/styles/edge'
$rad: 20
$lineH: 6
// $wid: 1500
.ProgressBar
    position: absolute
    // width: pxToRem($wid)
    // height: pxToRem(44)
    // background: yellow
    // margin: auto pxToRem(66) auto auto
    // border: solid 1px #000
    // box-shadow: 0px 2px 20px 0px rgba(0,0,0,0.11)
    // border-radius: pxToRem(8)
    // filter: blur(50px)
    // +flex-center()
    input[type=range]
        // position: absolute
        position: relative
        -webkit-appearance: none
        // width: pxToRem($wid)
        width: 100%
        // height: pxToRem($lineH*2)
        // border-radius: pxToRem($lineH)
        // background: #ddd no-repeat
        border-radius: pxToRem(50)
        background: -webkit-linear-gradient(#059CFA, #059CFA) no-repeat
        background-size: 100% 100%

    input[type=range]::-webkit-slider-runnable-track
        -webkit-appearance: none
        // background: #666
        // width: var(--vwid)
        // line-height: pxToRem(30)
        // width: pxToRem(10)
        height: pxToRem($lineH)
        border: solid 1px #eee
        border-radius: pxToRem(50)
        background: -webkit-linear-gradient(#ddd3, #ddd3) no-repeat
        background-size: 100% 100%
        
    input[type=range]::-webkit-slider-thumb
        -webkit-appearance: none
        width: pxToRem($rad)
        height: pxToRem($rad)
        background: #fff
        box-shadow: 0 pxToRem(2) pxToRem(8) 0 rgba(0,0,0,0.3)
        border-radius: 50%
        margin-top: pxToRem(-$rad/2+$lineH/2)
        cursor: pointer

</style>